module.exports = "/_next/static/images/invoice-order-tooltip-9a3d1169c5584469de11113f187fc529.svg";